<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2019年12月25日 14:32:56 +0800
 * @最后修改时间: 2022-02-18 11:28:29
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftType\newShiftType.vue
 -->
<template>
  <ContentLayout
    widthClass="max-1000"
    :initData="shiftTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'shift_type_name',
      'shift_type_abbr',
      'shift_type_code',
      'shift_type_description',
      'sequence',
    ]"
    backgroundClass="white"
    :title="$t('label_essweb_shiftType_form_newTitle')"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="shiftTypeData.shift_type_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  shiftTypeData.shift_type_name = valueArr;
                }
              "
              :label="$t('label_essweb_shiftType_form_typeNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="shiftTypeData.shift_type_abbr"
              @change="
                (valueArr) => {
                  shiftTypeData.shift_type_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_shiftType_form_typeAbbrLabel')"
              maxlength="20"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              v-model="shiftTypeData.shift_type_code"
              maxlength="20"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_ClaimReason_form_codeLabel')"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              v-model="shiftTypeData.sequence"
              maxlength="255"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 255])
              "
              :label="$t('label_essweb_shiftType_form_sequenceLabel')"
              type="number"
              isNotRequire
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="shiftTypeData.shift_type_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  shiftTypeData.shift_type_description = valueArr;
                }
              "
              :label="$t('label_essweb_shiftType_form_descriptionLabel')"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="newShiftType" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newType",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      isChanged: false,
      shiftTypeData: {
        shift_type_name: "",
        shift_type_code: "",
        sequence: 1,
        shift_type_description: "",
        shift_type_abbr: "",
      },
    };
  },
  watch: {},
  mounted() {
    const that = this;
  },
  methods: {
    newShiftType: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/add-shift-type-table/",
        data: {
          shift_type_name: this.$transCommonLangKey(
            this.shiftTypeData.shift_type_name
          ),
          shift_type_description: this.$transCommonLangKey(
            this.shiftTypeData.shift_type_description
          ),
          shift_type_abbr: this.$transCommonLangKey(
            this.shiftTypeData.shift_type_abbr
          ),
          shift_type_code: this.shiftTypeData.shift_type_code,
          sequence: this.shiftTypeData.sequence,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
